import { services } from "../../../../constants/services";
import { getByQuery } from "../../../../utils/api";
import { ResponseQ } from "../../../../common/dtos/paginate.dto";

export class GetEmailsLogsWithPaginationService {
  async run(params: any) {
    const response = await getByQuery<ResponseQ<any>>(`${services.logBooking}/getEmailLogs`, params);
    return response;
  };
}

